// extracted by mini-css-extract-plugin
export default {"controlsContainer":"Colleges_controlsContainer__nmoLk"};